
<style scoped>
</style>

<template>
  <div>
    <Card shadow>
      <Select
        :transfer="true"
        v-model="selectExpireDate"
        style="width:200px"
        @on-change="getExpireDist"
        placeholder="请选择过期时间"
      >
        <Option
          v-for="item in expireDateList"
          :value="item.expiredate"
          :key="item.expiredate"
        >{{ item.displaydate }}</Option>
      </Select>
      <Button
        style="margin-left:10px"
        type="primary"
        @click="exportExcel"
      >导出Excel</Button>
      <!-- <Button style="margin-left:10px" type="primary" @click="testDate">testDate</Button> -->
      <Table
        stripe
        :columns="tdata.col_data"
        :data="tdata.current_data"
        :loading="tdata.loading"
        style="margin-top:10px"
        @on-row-click="rowselect"
      >
        <template
          slot-scope="{row}"
          slot="updateurl"
        >
          <a @click.stop="openDistUrl(row.cerUpdateDistUrl)">{{row.cerUpdateDistUrl}}</a>
        </template>
      </Table>
    </Card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expireDateList: [],
      selectExpireDate: null,
      tdata: {
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "index",
            width: 60,
            align: "center",
          },
          {
            title: "项目名称",
            key: "projectname",
          },
          {
            title: "应用名称",
            width: 200,
            key: "appname",
          },
          {
            title: "项目经理",
            width: 250,
            key: "pmname",
          },
          // {
          //   title: "是否更新",
          //   width: 120,
          //   key: "cerUpdate",
          // },
          {
            title: "更新地址",
            slot: "updateurl",
          },
        ],
      },
    };
  },
  methods: {
    openDistUrl(url) {
      window.open(url, "_blank");
    },
    getExpireDateList() {
      let _this = this;
      this.$http.get({
        method: "mqms/iosdist/expiredatelist",
        params: {},
        success: function (data) {
          _this.expireDateList = data;
          if (data.length > 0) {
            _this.selectExpireDate = data[0].expiredate;
            _this.getExpireDist(data[0].expiredate);
          }
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    getExpireDist(date) {
      let _this = this;
      this.$http.get({
        method: "mqms/iosdist/distinfov2",
        params: {
          expiredate: date,
        },
        success: function (data) {
          // alert(JSON.stringify(data))
          _this.tdata.current_data = data;
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    rowselect(row) {
      window.open("#/appdistv2/" + row.projectguid);
    },
    exportExcel() {
      let _this = this;
      this.$http.get({
        method: "mqms/iosdist/exportexpireexcel",
        params: {
          expiredate: this.selectExpireDate,
        },
        success: function (data) {
          window.location.href =
            _this.$axios.defaults.baseURL +
            "/mqms/iosdist/downloadexpirexls?filename=" +
            data;
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    testDate() {
      let _this = this;
      let date = new Date(this.selectExpireDate);
      this.$http.get({
        method: "mqms/iosdist/testdate",
        params: {
          expiredate: date.valueOf(),
        },
        success: function (data) {},
      });
    },
  },
  mounted() {
    this.getExpireDateList();
  },
};
</script>